import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getEventBus } from 'apps-common'
import { removeRootPath } from '@/features/layout/utils/removeRootPath'

type EventPayload = string

const eventName = 'navigationEvent'

const createLocaleSwitcherEventSubscriber = (fn: (event: CustomEvent<EventPayload>) => void) => ({
  subscribe: () => getEventBus<EventPayload>().on(eventName, fn),
  unsubscribe: () => getEventBus<EventPayload>().off(eventName, fn),
})

export const NavigationEventBus = () => {
  const navigate = useNavigate()

  const handleNavigationEvent = useCallback(
    (event: CustomEvent<EventPayload>) => {
      const path = event.detail

      if (!path) {
        throw new Error('Path is not provided')
      }

      const relativePath = removeRootPath(path)
      navigate(relativePath)
    },
    [navigate],
  )

  useEffect(() => {
    const { subscribe, unsubscribe } = createLocaleSwitcherEventSubscriber(handleNavigationEvent)
    subscribe()
    return () => {
      unsubscribe()
    }
  }, [handleNavigationEvent])

  return null
}
